<template>
  <div class="card order-details" v-if="data.length!=0" id="renewal-order" ref="renewalorder" :style="renewalOrderStyle" >
    <div class="card-header">Renewal Order Details</div>
    <div class="card-body table-scroll">
      <table class="table table-borderless ">
        <thead class="thead-light">
          <tr>
            <th>SAP Order Number</th>
            <th>SAP SKU</th>
            <th>SAP Line Item Number</th>
            <th>Quantity</th>
            <th>High Level Item</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data" :key="item.SAPLineItemNumber">
            <td>{{ item.SAPOrderNumber }}</td>
            <td>{{ item.SAPSKU }}</td>
            <td>{{ item.SAPLineItemNumber }}</td>
            <td>{{ item.QUANTITY }}</td>
            <td>{{ item.HIGHLEVELITEM }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
   <div class="card order-details" v-else id="renewal-order" ref="renewalorder" :style="renewalOrderStyle">
      <div class="card-header">Renewal Order Details</div>
    <div class="card-body ">
        No Renewal Order Found.
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'LicenseCheckerRenewalOrderDetails',
  props: {
    data: { type: Array, default: () => ([]) },
    height: { type: String, default: '' }
  },
  data () {
    return {
      renewalOrderStyle: { }
    }
  },
  mounted () {
  },
  watch: {
    height (newval, oldval) {
      this.$set(this.renewalOrderStyle, 'height', this.height + 'px')
      this.$set(this.renewalOrderStyle, 'overflow-y', 'auto')
    }
  }
}
</script>

<style>
.order-details.card {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/license-checker/license-checker-renewal-order-details.vue